import React, { useState } from 'react';
import { Button, Row, Col } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { emailValidator, uncheckCheckBoxes } from '../../common/sharedFunctions';
import { EmailFieldFormatter } from '../FieldFormatter/EmailFieldFormatter';
import { PhoneFieldFormatter, phoneValidator } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import '../../styles/UnSubModal.scss';
import constants from '../../constants/constants';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import TableDataShape from '../../shapes/TableData';

export function SignUpModal({
  handleSignUpCallBack, type, setSelectedItems, tableData, selectedItems, setTableData, setSignUp
}) {

  const isEmail = type === constants.EMAIL;
  const [input, setInput] = useState('');

  const isEnabled = (isEmail) ? emailValidator(input) : phoneValidator(input);

  const handleSignUp = () => {
    handleSignUpCallBack(input);
    setSignUp(false);
  };

  const handleClose = () => {
    const updatedTableData = uncheckCheckBoxes(tableData, selectedItems);
    setTableData(updatedTableData);
    setSelectedItems([]);
    setSignUp(false);
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
    >
      <div className="preferences-modal__content">
        <Row>
          <Col>
            <h1>{isEmail ? constants.EMAIL_SIGNUP_HEADER_TEXT : constants.SMS_SIGNUP_HEADER_TEXT}</h1>
            <br />
            <h2>{isEmail ? constants.EMAIL_SIGNUP_TEXT : constants.SMS_SIGN_UP_TEXT}</h2>
            <br />
            <Row>
              <Col md={6}>
                {isEmail ? (
                  <EmailFieldFormatter callback={setInput} value={input} name="sign-up" />
                ) : (
                  <PhoneFieldFormatter callback={setInput} value={input} name="sign-up" />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="hr-line" />
        <Row>
          <Col md="9" />
          <Col md="3">
            <Button onClick={handleSignUp} disabled={!isEnabled}>Sign Up</Button>
          </Col>
        </Row>
      </div>
    </MobileAwareOverlay>
  );
}

SignUpModal.propTypes = {
  handleSignUpCallBack: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  setSignUp: PropTypes.func.isRequired,
  setTableData: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  tableData: TableDataShape.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};
